import COLOR from "../../../../constants/colors";

const styles = {
  item: {
    background: COLOR.white,
    padding: 24,
    marginBottom: 24,
    fontSize: "1rem",
    boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
  },
};

export default styles;
